module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/11-1979ed9a77351eca2d3ed14bacfd0384.jpg";